<script setup></script>
<template>
  <section class="container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1344"
      height="2"
      viewBox="0 0 1344 2"
      fill="none"
    >
      <path
        d="M0 1H1344"
        stroke="white"
        stroke-opacity="0.2"
        stroke-width="1.5"
        stroke-dasharray="2 6"
      />
    </svg>
  </section>
</template>
